<template>
  <div>
    <el-card style="margin-top: 15px;">
      <el-row class="title_row">
        <el-col :span="12">
          <span class="title_class">审核进度</span>
        </el-col>
        <el-col :span="12" align="right">
          <el-button type="primary" plain size="small" icon="el-icon-plus">发布课程</el-button>
        </el-col>
      </el-row>
      <el-table :data="auditList" style="margin-top: 15px">
        <el-table-column prop="productName" label="产品名称" align="center"></el-table-column>
        <el-table-column prop="price" label="产品价格" align="center"></el-table-column>
        <el-table-column label="审批等级" align="center">一级部门</el-table-column>
        <el-table-column label="审批意见" align="center">同意</el-table-column>
        <el-table-column prop="creator" label="创建人" align="center"></el-table-column>
        <el-table-column prop="createTime" label="申请日期" align="center"></el-table-column>
        <el-table-column prop="createTime" label="更新日期" align="center"></el-table-column>
        <el-table-column prop="auditStatus" label="审批状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.auditStatus === 0" type="warning" size="small">待审核</el-tag>
            <el-tag v-else-if="scope.row.auditStatus === 1" type="success" size="small">通过</el-tag>
            <el-tag v-else-if="scope.row.auditStatus === 2" type="danger" size="small">拒绝</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template>
            <el-button type="text" size="mini">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-row :gutter="20">
      <el-col :span="24" v-for="(dItem, j) in list" :key="j">
        <el-card style="margin-top: 15px;">
        <el-row class="title_row">
          <el-col>
            <span class="title_class">{{ dItem.name }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="6" v-for="(item, i) in dItem.productList" :key="i">
            <div class="camp-item">
              <div class="bar"></div>
              <div class="panel panel1">
                <div class="name">{{ item.productName }}</div>
                <!-- <div class="date">{{ item.tbProductDetails[0].description }}</div> -->
                <div class="price">¥ {{ item.tbProductDetails[0].price }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      list: [],
      auditList: [
        { productName: '大师课', price: '¥5800', creator: '张三', createTime: '2026-06-01', auditStatus: 0 }
      ]
    }
  },
  created () {
    this.getDataList()
  },
  methods: {
    getDataList () {
      this.$http.get('productMaintain/kechengList').then((res) => {
        this.list = res.data
      }).catch((err) => {
        console.log('err', err)
      })
    },
    formatDate (date) {
      return date.slice(0, 10)
    },
    formatDate2 (date) {
      return date.slice(5, 10)
    }
  }
}
</script>

<style scoped lang="less">
  .camp-item{
    width: 100%;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    &:hover{
      box-shadow: 0 4px 12px 0 rgba(0,0,0,.4);
    }
    .bar{
      width: 100%;
      height: 6px;
      background-color: #f9d64a;
      border-radius: 10px 10px 0 0;
    }
    .panel{
      padding: 10px 12px;
      border-radius: 0 0 10px 10px;
      .name{
        height: 40px;
        color: #000;
        font-size: 14px;
        font-weight: bold;
      }
      .flex{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #969696;
        font-size: 12px;
      }
      .date{
        color: #666;
        font-size: 11px;
        margin-top: 8px;
        height: 60px;
      }
      .price{
        font-weight: bold;
        font-size: 18px;
        color: #f00;
        margin-top: 10px;
      }
      &.panel1{
        background: linear-gradient(140deg, #fde480 0%, #fff 80%, #fff 100%);
      }
    }
  }
  .paper-card2{
  cursor: pointer;
  height: 240px;
  width: 100%;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 12px 0px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img{
    width: 120px;
    height: 120px;
    margin-bottom: 10px;
  }
  font-size: 16px;
  color: #79BBFF;
}
</style>
